import PropTypes from "prop-types";
import React from "react";
import FormField from "./FormField";

const titleOptions = [
  'Mr.',
  'Mrs.',
  'Ms.',
  'Dr.',
];

const suffixOptions = [
  "Jr",
  "Sr",
  "II",
  "III",
  "IV"
];

const NameField = ({entity, hideTitle = false, required}) => {
  return (
    <React.Fragment>
      {!hideTitle && (
        <div className="row">
          <FormField label="Title" type="select" name={`${entity}.name_title`} options={titleOptions} colWidth={3}/>
        </div>
      )}
      <div className="row">
        <FormField label="First Name" type="text" name={`${entity}.first_name`} colWidth={6} required={required} />
        <FormField label="Middle Name" type="text" name={`${entity}.middle_name`} colWidth={6}/>
        <FormField label="Last Name" type="text" name={`${entity}.last_name`} colWidth={6} required={required} />
        <FormField label="Suffix" type="select" name={`${entity}.name_suffix`} options={suffixOptions} colWidth={3}/>
      </div>
      <div className="row">
        <FormField label="Preferred Name" type="text" name={`${entity}.preferred_name`} colWidth={6}/>
      </div>
    </React.Fragment>
  );
}

NameField.defaultProps = {
  hideTitle: false,
  required: false
};

NameField.propTypes = {
  hideTitle: PropTypes.bool,
  entity: PropTypes.string.isRequired,
  required: PropTypes.bool
};

export default NameField;
